import {setCookie} from '~/shared/utils/cookie';
import {rtkQueryApi} from '~/shared/api/rtk-query-api';

export const loginApi = rtkQueryApi.injectEndpoints({
  endpoints: builder => ({
    getLogin: builder.query({
      query: () => ({
        url: '/login',
        method: 'GET',
      }),
      transformResponse: resp => {
        setCookie('auth-token', resp.token);
      },
    }),
    getDebugUsers: builder.query({
      query: () => ({
        url: '/auth/users',
        method: 'GET',
      }),
    }),
    loginAs: builder.mutation({
      query: ({ user_id }) => ({
        url: '/auth/login-as',
        method: 'POST',
        body: new URLSearchParams({ user_id: String(user_id) }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }),
    }),
  }),
});

export const {useLazyGetLoginQuery, useGetDebugUsersQuery, useLoginAsMutation} = loginApi;
